import { render, staticRenderFns } from "./SupportContent.vue?vue&type=template&id=669ceade&"
import script from "./SupportContent.vue?vue&type=script&lang=js&"
export * from "./SupportContent.vue?vue&type=script&lang=js&"
import style0 from "./SupportContent.vue?vue&type=style&index=0&id=669ceade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports